import {Component, DestroyRef, OnInit, inject, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FirestoreService} from '../../services/firestore.service';
import {NavigationEnd, Router} from '@angular/router';
import {ClientInContextService} from '../../services/client-in-context.service';
import moment from 'moment';

import {MatToolbarModule} from '@angular/material/toolbar';
import {DatePipe} from '@angular/common';

/**
 * Top navigation bar component displaying real-time date/time, ISO week number,
 * active route tracking, and organization context.
 */
@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: true,
    imports: [MatToolbarModule, DatePipe]
})
export class NavComponent implements OnInit {
  public firestoreService = inject(FirestoreService);
  private router = inject(Router);
  public contextService = inject(ClientInContextService);
  private destroyRef = inject(DestroyRef);

  /** Signal holding the current active URL path without the leading slash. */
  url = signal<string>('');

  /** Signal holding the current timestamp string updated every second. */
  currentDate = signal<string | Date>(moment().format('YYYY-MM-DD HH:mm:ss'));

  /** Signal holding the current ISO week number. */
  weekNumber = signal<number>(moment().isoWeek());

  constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const urlAfterRedirects = event.urlAfterRedirects;
        this.url.set(urlAfterRedirects.substring(1, urlAfterRedirects.length));
      }
    });
  }

  /**
   * Starts 1-second interval timer to update `weekNumber` and `currentDate` signals.
   */
  ngOnInit(): void {
    const intervalId = setInterval(() => {
      this.weekNumber.set(moment().isoWeek());
      this.currentDate.set(moment().format('YYYY-MM-DD HH:mm:ss'));
    }, 1000);

    this.destroyRef.onDestroy(() => {
      clearInterval(intervalId);
    });
  }
}

